import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useLogin } from "../../hooks/useLogin";
import { useSignup } from "../../hooks/useSignup";

// Lista de emails de managers que precisam digitar senha manualmente
const MANAGER_EMAILS = [
  "admin@turminhaeduca.app",
  "modinez.carlos@gmail.com",
  "modinezgabriel@gmail.com",
];

// Senha padrão para todos os usuários (exceto managers)
const DEFAULT_PASSWORD = "123456";

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isCreatingAccount, setIsCreatingAccount] = useState<boolean>(false);
  const { login, success: loginSuccess, loading: loginLoading, error: loginError } = useLogin();
  const { signup, success: signupSuccess, loading: signupLoading, error: signupError } = useSignup();
  const navigate = useNavigate();

  // Verificar se o email é de um manager
  const isManagerEmail = (email: string): boolean => {
    return MANAGER_EMAILS.includes(email.toLowerCase().trim());
  };

  useEffect(() => {
    if (loginSuccess || signupSuccess) {
      navigate("/");
    }
  }, [loginSuccess, signupSuccess, navigate]);

  // Quando o email muda, verificar se precisa mostrar campo de senha
  useEffect(() => {
    if (email.trim()) {
      setShowPassword(isManagerEmail(email));
      // Se não for manager, limpar o campo de senha
      if (!isManagerEmail(email)) {
        setSenha("");
      }
    } else {
      setShowPassword(false);
      setSenha("");
    }
  }, [email]);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    const passwordToUse = isManagerEmail(email) ? senha : DEFAULT_PASSWORD;
    login({ email, senha: passwordToUse });
  };

  const handleCreateAccount = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      return;
    }
    // Para criar conta, sempre usar senha padrão e nome vazio (ou usar email como nome)
    const name = email.split("@")[0]; // Usar parte antes do @ como nome
    signup({ name, email, password: DEFAULT_PASSWORD });
  };

  const error = loginError || signupError;
  const loading = loginLoading || signupLoading;

  return (
    <div className="login-container">
      <img
        src="/turminha_logo.png"
        alt="Turminha Educa Logo"
        className="login-logo"
      />

      <form className="login-form-vertical" onSubmit={isCreatingAccount ? handleCreateAccount : handleLogin}>
        <input
          type="email"
          placeholder="Digite seu email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {showPassword && (
          <input
            type="password"
            placeholder="Digite sua senha"
            className="login-input"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />
        )}
        {error && <p className="login-error-message">{error}</p>}
        {!isCreatingAccount ? (
          <>
            <button className="login-button" type="submit" disabled={loading}>
              {loading ? "Entrando..." : "Entrar"}
            </button>
            <button
              className="login-button-secondary"
              type="button"
              onClick={() => setIsCreatingAccount(true)}
            >
              Criar Conta
            </button>
          </>
        ) : (
          <>
            <button className="login-button" type="submit" disabled={loading}>
              {loading ? "Criando conta..." : "Criar Conta"}
            </button>
            <button
              className="login-button-secondary"
              type="button"
              onClick={() => {
                setIsCreatingAccount(false);
                setEmail("");
                setSenha("");
                setShowPassword(false);
              }}
            >
              Voltar para Login
            </button>
          </>
        )}
      </form>
    </div>
  );
};

export default Login;
